import Vue from 'vue'
import VueRouter from 'vue-router'
//View landing
import Home from '../views/Home.vue'
//Route childrens
import profileChildren from './profile'
import postChildren from './post'
import accountChildren from './account'
import searchChildren from './search'
import createChildren from './create'
// Common sidebars and footers 
import footerMain from '@/components/footer/footer-main.vue'

/*
* Router init
*/
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        components: {
            default: Home
        }
    },
    {
        path: '/about/',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        components: {
            default: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
            'footer-main': footerMain
        }
    },
    {
        path: '/account/',
        components: {
            default: () => import( /* webpackChunkName: "account" */ '../views/Account.vue'),
            'footer-main': footerMain
        },
        children: accountChildren

    },
    {
        path: '/explore/',
        components: {
            default: () => import( /* webpackChunkName: "explore" */ '../views/Explore.vue'),
            'footer-main': footerMain
        },
        meta: { exploreTopbar: true }
    },
    
    {
        path: '/search/',
        components: {
            default: () => import( /* webpackChunkName: "search" */ '../views/Search.vue'),
            'footer-main': footerMain
        },
        children: searchChildren

    },

    {
        path: '/create/',
        components: {
            default: () => import( /* webpackChunkName: "create" */ '../views/Create.vue'),
            'footer-main': footerMain
        },
        children: createChildren

    },

    {
        path: '/terms/',
        components: {
            default: () => import( /* webpackChunkName: "terms" */ '../views/Terms.vue'),
            'footer-main': footerMain
        }
    },

    {
        path: '/privacy/',
        components: {
            default: () => import( /* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
            'footer-main': footerMain
        }
    },

    {
        path: '/not-found/',
        components: {
            default: () => import( /* webpackChunkName: "404" */ '../views/404.vue'),
            'footer-main': footerMain
        }
    },

    {
        path: '/post/:postId/',
        components: {
            default: () => import( /* webpackChunkName: "post" */ '../views/Post.vue'),
            'footer-main': footerMain
        },
        children: postChildren

    },

    {
        path: '/:username/',
        components: {
            default: () => import( /* webpackChunkName: "profile" */ '../views/Profile.vue'),
            'footer-main': footerMain
        },
        children: profileChildren

    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router